import { PageContentLayout } from "~/components/ui/page-content-layout";
import { PageHeader } from "~/components/ui/page-header";
import { PageLayout } from "~/components/ui/page-layout";
import { usePermissionData } from "./hooks/use-permission-data";
import { Permissions } from "./permissions";

const PermissionsContent = () => {
  const { isLoading, isError, userData, brandData, customerData } = usePermissionData();

  return (
    <PageLayout>
      <PageHeader title="Permissions" />
      <PageContentLayout>
        <Permissions
          isDataLoading={isLoading}
          isDataError={isError}
          users={userData || []}
          brands={brandData || []}
          customers={customerData || []}
        />
      </PageContentLayout>
    </PageLayout>
  );
};

export const PermissionsPage = () => {
  return <PermissionsContent />;
};
